import { useState } from "react";
import { resetState } from "../redux/auth/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { resetData } from "../redux/auth/loginDataSlice";
import Block from "../components/models/Block";
import AppLogo from "../components/AppLogo";
import { handleRouteNav } from "../utils";

const AccountBlock = () => {
  const [isDeleteModal, setIsDeleteModel] = useState(false);
  const [actionType, setActionType] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { is_blocked: isBlocked, role_id } = useSelector((state) => state.auth);

  if (!isBlocked) return <Navigate to="/" />;

  const handleLogout = () => {
    setIsDeleteModel(true);
    setActionType("Logout");
  };

  const handleCancel = () => {
    setIsDeleteModel(false);
  };

  const handleDeleteOk = () => {
    navigate(handleRouteNav("/login", role_id));
    dispatch(resetState());
    dispatch(resetData());
  };

  return (
    <>
      <div className="container-full">
        <div
          className="h-screen"
          style={{
            backgroundImage: "linear-gradient(180deg, #FFDBD4 36.74%, #F4F4F4 95.35%)",
          }}
        >
          <div className="flex py-6 justify-center items-center">
            <AppLogo />
          </div>
          <div className="flex flex-col mt-32 justify-between items-center">
            <div className="">
              <img src="/assets/images/block.svg" className="w-full" alt="logo" />
            </div>
            <div className="flex flex-col justify-between items-center">
              <p className=" text-2xl mt-4 font-[400]">
                Account has been blocked
              </p>
              <div className="w-full mt-12 flex justify-center">
                <button onClick={handleLogout} className="text-[#A23333] font-semibold">
                  Log Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Block
        open={isDeleteModal}
        onCancel={handleCancel}
        onConfirm={handleDeleteOk}
        title={"Do you want to Log Out?"}
        confirmText={"Log Out"}
      />
    </>
  );
};

export default AccountBlock;
